import React, { FC } from 'react'

import { IconExpressDeliveryProps } from './IconExpressDelivery.types'
import * as Styled from './styles/IconExpressDelivery.style'

import { nonThemeableRules } from '../../ruleSet'

const IconExpressDelivery: FC<IconExpressDeliveryProps> = ({
  size = nonThemeableRules.defaultSize as number as IconExpressDeliveryProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconExpressDeliveryProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 192 192' xmlns='http://www.w3.org/2000/svg'>
        <path d='M37.9 158.5h-.09a18.92 18.92 0 0 1-18.44-19.31V139h-.84A18.6 18.6 0 0 1 0 120.38v-11a4 4 0 0 1 8 0v11A10.59 10.59 0 0 0 18.53 131H24a4 4 0 0 1 3.85 5.07 12.26 12.26 0 0 0-.43 3.19A10.93 10.93 0 0 0 37.9 150.5a10.91 10.91 0 0 0 10.52-11.16 12.73 12.73 0 0 0-.45-3.28 4 4 0 0 1 3.86-5.06h64.38V52.12a10.59 10.59 0 0 0-10.53-10.62H18.53C13.44 41.5 8 43.77 8 50.12a4 4 0 0 1-8 0C0 40.34 7.62 33.5 18.53 33.5h87.15a18.59 18.59 0 0 1 18.53 18.62V53h51.68a4 4 0 0 1 3.77 2.66l12.11 34.13a4 4 0 0 1 .23 1.33v29.23A18.6 18.6 0 0 1 173.47 139l-10.94.06v.2a18.53 18.53 0 1 1-37.06 0V139H56.42v.23A18.92 18.92 0 0 1 38 158.5Zm86.31-27.5h5.84a4 4 0 0 1 3.86 5.06 11.73 11.73 0 0 0-.43 3.18 10.53 10.53 0 1 0 21.06.11 25.38 25.38 0 0 0-.47-3.47 4 4 0 0 1 3.9-4.81l15.48-.09A10.59 10.59 0 0 0 184 120.35V91.81L173.07 61h-48.86Z' />
        <path d='M4 62.5h81a4 4 0 0 1 4 4 4 4 0 0 1-4 4H4a4 4 0 0 1-4-4 4 4 0 0 1 4-4Zm9 15h81a4 4 0 0 1 4 4 4 4 0 0 1-4 4H13a4 4 0 0 1-4-4 4 4 0 0 1 4-4Zm9 15h81a4 4 0 0 1 4 4 4 4 0 0 1-4 4H22a4 4 0 0 1-4-4 4 4 0 0 1 4-4Z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconExpressDelivery
